/**
 * Learner API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'
const mainApi = {
    // 나의 학습목록(get learning list)
    // https://clpapi.tinkeredu.co.kr/learn/degree/category
    fetCategory() {
        return httpService.get(`/learn/degree/category`)
    },

    // 나의 학습목록(get learning list)
    // https://clpapi.tinkeredu.co.kr/samsung/star/membership/member/activity
    fetMember() {
        return httpService.get(`/membership/member`)
    },

    // fetMember() {
    //     return httpService.get(`/membership/member/activity`)
    // },

    // 나의 학습목록(get Recent view)
    // https://clpapi.tinkeredu.co.kr/samsung/star/learn/learner/online/last
    fetchRecent() {
        return httpService.get(`/samsung/star/learn/learner/online/last`)
    },

    // 나의 학습목록(get new video talk)
    // https://clpapi.tinkeredu.co.kr/samsung/star/learn/learner/online/last?categories=14
    fetchNewVideoTalk() {
        return httpService.get(`/samsung/star/learn/learner/online/last?categories=1`)
    },

    // 나의 학습목록(get Recent Learning)
    // https://clpapi.tinkeredu.co.kr/static/docs/online_degree_list.html#resources-degree-online-recommendable-page
    fetchRecommendedList(params) {
        return httpService.get(`/learn/online/target?type=RECOMMENDABLE`,params)
    },

    // 나의 학습목록(get Recent Content)
    // https://clpapi.tinkeredu.co.kr/samsung/star/learn/online/recent?itemCount=5
    fetchRecentContent(params) {
        //return httpService.get(`/samsung/star/learn/learner/online/recent?itemCount=5`)
        return httpService.get(`/learn/learner/online?status=LEARNING&page=1&size=${params.size}&sort=id,desc`)
        
    },
    
    fetchRecentMicroContent(params) {
        //return httpService.get(`/samsung/star/learn/learner/online/recent?itemCount=5`)
        return httpService.get(`/micro/learn/learner/online?status=LEARNING&page=1&size=${params.size}&sort=id,desc`)
        
    },

    // 나의 학습목록(get Recent Learning)
    fetchRecentLearning() {
        //return httpService.get(`/samsung/star/learn/learner/online/recent?itemCount=5`)
        return httpService.get(`/learn/learner/online/recent?itemCount=5`)
        
    },

    // 나의 스킬패스 학습목록(get Recent Learning)
    fetchRecentMicroLearning() {
        //return httpService.get(`/samsung/star/learn/learner/online/recent?itemCount=5`)
        return httpService.get(`/micro/learn/learner/online/recent?itemCount=5`)
        
    },

    // Subject
    fetchSubject(params) {
        return httpService.get(`/learn/subject?page=${params.page}&size=${params.size}`)  
    },

    // Micro Subject
    fetchMicroSubject(params) {
        return httpService.get(`/micro/learn/subject?page=${params.page}&size=${params.size}`)
    },

    // fetch popular tag
    //https://dev.clp.kr/spc/api/static/docs/index.html#resources-common-tag-popularity
    fetchPopularTag() {
        return httpService.get(`/common/tag/popularity`)
    },
    // fetch popular tag learn online data
    //https://dev.clp.kr/spc/api/static/docs/online_degree_list.html#resources-degree-online-page 
    fetchPopularTagLearn(params) {
        return httpService.get(`/learn/online?sort=id,desc&page=1&size=${params.size}&tags=${params.tags}`)
    },
    
    fetchPopularTagMicroLearn(params) {
        return httpService.get(`/micro/learn/online?sort=id,desc&page=1&size=${params.size}&tags=${params.tags}`)
    },
    // fetch popular tag exam independent data
    //https://dev.clp.kr/spc/api/static/docs/exam_independent.html#resources-exam-independent 
    fetchPopularTagExam(params) {
        return httpService.get(`/exam/independent?sort=id,desc&page=1&size=${params.size}&tags=${params.tags}`)
    },
    // fetch popular tag survey independent data
    //https://dev.clp.kr/spc/api/static/docs/survey_independent.html#resources-survey-independent-page  
    fetchPopularTagSurvey(params) {
        return httpService.get(`/survey/independent?sort=id,desc&page=1&size=${params.size}&tags=${params.tags}`)
    },
    // fetch popular tag board communitytype community data
    //https://dev.clp.kr/spc/api/static/docs/front_board.html#resources-tag-article-fetch 
    fetchPopularTagCommunity(params) {
        return httpService.get(`/board?communityType=COMMUNITY&sort=id,desc&size=${params.size}&tags=${params.tags}`)
    },
        // fetch popular tag board communitytype SOCIAL_LEARNING data
    //https://dev.clp.kr/spc/api/static/docs/front_board.html#resources-tag-article-fetch 
    fetchPopularTagSocialLearning(params) {
        return httpService.get(`/board?communityType=SOCIAL_LEARNING&sort=id,desc&size=${params.size}&tags=${params.tags}`)
    },

    //사용자의 메인 페이지 게시판 조회 - (Front Main Board Fetch)
    getBoard() {
        return httpService.get(`/board/main`)
    },
}

// export const 
export default mainApi
